import { cn } from '@/lib/utils';

/**
 * A component that displays text within double quotes.
 * The text is truncated with an ellipsis if it overflows,
 * ensuring the closing quote always remains visible.
 */
function TruncatedText({ text, className }: { text: string; className: string }) {
	return (
		// Use inline-flex to keep quotes and text on one line.
		// max-w-full is crucial for allowing truncate to work within a flex container.
		<span className={cn('inline-flex min-w-0 max-w-full items-baseline', className)}>
			{/* Opening quote */}
			<span>"</span>

			{/* The text itself, which is the only part that truncates */}
			<span className="truncate">{text}</span>

			{/* Closing quote, which will always be visible */}
			<span>"</span>
		</span>
	);
}

export { TruncatedText };
